const metaItemActive = {
  itemActive: 'Parameters',
};
export default [
  {
    path: '/parameters',
    name: 'Parameters',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Parameters',
      crud: {
        pageTitle: 'app.parameters.title',
        showCard: false,
        pageContent: () => import('App/parameters/Parameters.vue'),
      },
    },
  },
  {
    path: '/parameters/score',
    name: 'ScoreParameters',
    component: () => import('App/parameters/ScoreParametersForm.vue'),
    meta: metaItemActive,
  },
  {
    path: '/parameters/automatic-payment',
    name: 'AutomaticPayment',
    component: () => import('App/parameters/AutomaticPaymentForm.vue'),
    meta: metaItemActive,
  },
  {
    path: '/parameters/overdue-billet',
    name: 'OverdueBilletParameters',
    component: () => import('App/parameters/OverdueBilletParametersForm.vue'),
    meta: metaItemActive,
  },
  {
    path: '/parameters/extension-parameters/:id',
    name: 'ExtensionParameters',
    component: () => import('App/parameters/ExtensionParametersForm.vue'),
    meta: metaItemActive,
  },
];
